const initState = {
    insufficientStock: false
}

const marketReducer = (state = initState, action) => {
    switch(action.type) {
        case 'TRADE_EXECUTED':
            console.log('trade has been inserted')
            return state

        case 'TRADE_ACTIVATED':
            console.log('trade has been activated')
            return state
        
        case 'TRADE_EXECUTE_FAILED':
            console.log('trade has failed')
            return state

        case 'INSUF_STOCK':
            console.log('insufficient amount of stock!')
            state = {
                ...state,
                insufficientStock: true
            }

            return state
                    
        case 'ORDER_FILLED':
            console.log('order has been filled')
            return state

        default:
            return state;
    }
}

export default marketReducer;